import { Accordion, AccordionDetails, AccordionSummary, AppBar, Button, Dialog, DialogContent, Grid, IconButton, LinearProgress, Tab, Tabs, Tooltip } from '@material-ui/core';
import { AccountBalanceWallet, AccountBalanceWalletRounded, Block, CalendarToday, CheckCircleOutline, Close, Code, Deck, Edit, Email, ExpandMore, FileCopy, Fingerprint, FlipToBackRounded, FormatAlignCenter, HourglassEmpty, Inbox, KeyboardHideSharp, Layers, Money, OpenInNew, People, Person, Phone, PlayCircleOutline, Star, TransferWithinAStation, VerifiedUser, Visibility, VpnKey } from '@material-ui/icons';
import moment from 'moment';
import MUIDataTable from 'mui-datatables';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import * as Toastr from "toastr";
import _ from "underscore";
import { getTransactionUrl } from '../../helpers/utility';
import { approveTokenRequest, fetchMemberReferalRequest, fetchMembersRequest, resetMemberRequest, resumeMemberRequest, suspendMemberRequest } from '../../store/member/member.actions';
import { getMembers } from '../../store/member/member.selector';
import { fetchPlanMemberRequest, fetchPlansRequest } from '../../store/plan/plan.actions';
import { getMemberContracts, getMemberPayouts, getMemberSwaps, getMemberWithdraws, getPlanMembers, getPlans } from '../../store/plan/plan.selector';
import TitleBar from '../base/TitleBar';
import Loader from '../base/loader';
import ReferalContainer from './Referal.Container';
import AddMember from './addMember';
import UpdateMember from './editMember';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const OK_STATES = ["active", "approved", "completed", "success", "successful", "paid", "verified", "done"];
const WARN_STATES = ["pending", "processing", "initiated", "inprogress", "in progress", "waiting", "requested", "submitted"];
const BAD_STATES = ["rejected", "failed", "suspended", "cancelled", "canceled", "blocked", "expired"];

const toneOf = (status) => {
    const value = (status || "").toString().trim().toLowerCase();
    if (OK_STATES.indexOf(value) > -1) return "ok";
    if (WARN_STATES.indexOf(value) > -1) return "warn";
    if (BAD_STATES.indexOf(value) > -1) return "bad";
    return "info";
};

const initialsOf = (first, last) => {
    const value = `${(first || "").charAt(0)}${(last || "").charAt(0)}`.trim().toUpperCase();
    return value || "?";
};

const copyToClipboard = (value, label) => {
    if (!value) return;
    navigator.clipboard.writeText(value);
    Toastr.info(`${label || "Value"} copied to clipboard`);
};

function StatusPill({ status, fallback }) {
    if (!status) {
        return <span className="member-pill member-pill-muted">{fallback || "—"}</span>;
    }
    return <span className={`member-pill member-pill-${toneOf(status)}`}>{status}</span>;
}

function CopyButton({ value, label }) {
    return (
        <Tooltip title={`Copy ${label || "value"}`}>
            <span>
                <IconButton className="member-copy" disabled={!value} onClick={() => copyToClipboard(value, label)}>
                    <FileCopy />
                </IconButton>
            </span>
        </Tooltip>
    );
}

function Field({ icon, label, value, trailing, md }) {
    return (
        <Grid item xs={12} sm={12} md={md || 6} lg={md || 6}>
            <div className="member-field">
                <span className="member-field-icon">{icon}</span>
                <div className="member-field-body">
                    <span className="member-field-label">{label}</span>
                    <span className="member-field-value">{value || value === 0 ? value : "—"}</span>
                </div>
                {trailing && <span className="member-field-trail">{trailing}</span>}
            </div>
        </Grid>
    );
}

function Section({ icon, title, note, children }) {
    return (
        <div className="member-section">
            <div className="member-section-head">
                {icon}
                <h4>{title}</h4>
                {note && <small>{note}</small>}
            </div>
            {children}
        </div>
    );
}

function EmptyState({ title, text }) {
    return (
        <div className="member-empty">
            <Inbox />
            <strong>{title}</strong>
            <span>{text}</span>
        </div>
    );
}

function AccordionRow({ cells, status, children }) {
    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <div className="member-acc-summary">
                    {cells.map((cell, index) => (
                        <span className="member-acc-cell" key={index}>
                            <span>{cell.label}</span>
                            <strong>{cell.value || "—"}</strong>
                        </span>
                    ))}
                    <span className="member-acc-status"><StatusPill status={status} /></span>
                </div>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2} className="member-grid">
                    {children}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default function MemberContainer() {
    const dispatch = useDispatch();
    const [selectedItem, setSelecteItem] = useState({});
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState("Profile");
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [value, setValue] = React.useState(0);
    const [page, setPage] = useState(null);
    const [searchText, setSearchText] = useState("");

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const { members, planMembers, plans, walletInfo, isLoading, payouts, withdraws, contracts, swaps, totalMembers } = useSelector((state) => {
        return {
            members: getMembers(state),
            planMembers: getPlanMembers(state),
            plans: getPlans(state),
            payouts: getMemberPayouts(state),
            withdraws: getMemberWithdraws(state),
            contracts: getMemberContracts(state),
            swaps: getMemberSwaps(state),
            totalMembers: state.MemberReducer.totalMembers,
            isLoading: state.MemberReducer.isLoading,
            walletInfo: state.PlanReducer.walletInfo
        }
    }, []);

    useEffect(() => {
        dispatch(fetchMembersRequest({
            page: 0,
            pageSize: 10
        }));
        dispatch(fetchPlansRequest());
    }, [])

    useEffect(() => {
        setOpen(false);
        setSelecteItem({});
        setMode("");
    }, [members]);

    useEffect(() => {
        if (selectedItem.memberId) {
            dispatch(fetchMemberReferalRequest(selectedItem.memberId));
            dispatch(fetchPlanMemberRequest(selectedItem._id));
        }
    }, [selectedItem])

    const memberOf = (tableMeta) => _.find(members, (x) => x.memberId === tableMeta.rowData[0]) || {};

    const activatedCount = members.filter((x) => x.planMember && x.planMember.length > 0).length;
    const pendingCount = members.length - activatedCount;
    const planCount = members.reduce((total, x) => total + ((x.planMember && x.planMember.length) || 0), 0);

    const stats = [
        { key: "total", tone: "blue", icon: <People />, value: totalMembers || members.length, label: "Total Members", note: "Directory" },
        { key: "active", tone: "green", icon: <VerifiedUser />, value: activatedCount, label: "Activated", note: "This page" },
        { key: "pending", tone: "amber", icon: <HourglassEmpty />, value: pendingCount < 0 ? 0 : pendingCount, label: "Awaiting Activation", note: "This page" },
        { key: "plans", tone: "red", icon: <Layers />, value: planCount, label: "Plans Subscribed", note: "This page" },
    ];

    const actionRenderer = () => {
        return ({
            name: 'id',
            label: 'Action',
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => {
                    let dep = _.find(members, x => x._id === value);
                    return (
                        <div className="member-row-actions">
                            <Tooltip title="View member">
                                <IconButton
                                    onClick={() => {
                                        setOpen(true);
                                        setSelecteItem(dep);
                                        setMode("Profile");
                                    }}
                                >
                                    <Visibility />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title="Edit member">
                                <IconButton
                                    className="member-action-edit"
                                    onClick={() => {
                                        setSelecteItem(dep);
                                        setMode("edit");
                                    }}
                                >
                                    <Edit />
                                </IconButton>
                            </Tooltip>
                        </div>
                    );
                }
            }
        });
    };

    const columns = [{
        name: 'memberId',
        label: 'Member',
        options: {
            filter: false,
            sort: false,
            customBodyRender: (value, tableMeta) => {
                const member = memberOf(tableMeta);
                const name = `${member.firstName || ""} ${member.lastName || ""}`.trim();
                return (
                    <div className="member-cell">
                        <span className="member-cell-avatar">{initialsOf(member.firstName, member.lastName)}</span>
                        <span className="member-cell-body">
                            <span className="member-cell-name">{name || "Unnamed member"}</span>
                            <span className="member-cell-id">#{value}</span>
                        </span>
                    </div>
                );
            }
        }
    },
    {
        name: 'email',
        label: 'Contact',
        options: {
            filter: false,
            sort: false,
            customBodyRender: (value, tableMeta) => {
                const member = memberOf(tableMeta);
                return (
                    <span className="member-cell-sub">
                        <span title={value}>{value || "—"}</span>
                        <span>{member.mobileNumber || "—"}</span>
                    </span>
                );
            }
        }
    },
    {
        name: 'createdAt',
        label: 'Joined On',
        options: {
            filter: false,
            sort: false,
            customBodyRender: (value) => (
                <span className="member-datecell">
                    <strong>{moment(value).format("ll")}</strong>
                    <span>{moment(value).fromNow()}</span>
                </span>
            )
        }
    },
    {
        name: 'planMember',
        label: 'Plans',
        options: {
            filter: false,
            sort: false,
            customBodyRender: (value) => {
                const count = (value && value.length) || 0;
                return <span className={`member-count ${count === 0 ? "member-count-zero" : ""}`}>{count}</span>;
            }
        }
    },
    {
        name: 'planMember',
        label: 'Activated On',
        options: {
            filter: false,
            sort: false,
            customBodyRender: (value) => {
                if (!value || value.length === 0) {
                    return <span className="member-pill member-pill-warn">Not Activated</span>;
                }
                let activationDate = value[0].createdAt;
                if (value.length > 1) {
                    activationDate = _.sortBy(value, t => moment(t.createdAt).unix())[0].createdAt;
                }
                return (
                    <span className="member-datecell">
                        <strong>{moment(activationDate).format("ll")}</strong>
                        <span>{moment(activationDate).fromNow()}</span>
                    </span>
                );
            }
        }
    },
    {
        name: 'referal',
        label: 'Referral',
        options: {
            filter: false,
            sort: false,
            customBodyRender: (value) => value
                ? <span className="member-pill member-pill-info member-pill-plain">{value}</span>
                : <span className="member-pill member-pill-muted member-pill-plain">Direct</span>
        }
    },
    {
        name: 'status',
        label: 'Status',
        options: {
            filter: false,
            sort: false,
            customBodyRender: (value) => <StatusPill status={value} fallback="Unknown" />
        }
    },
    actionRenderer()
    ];

    const datum = members.map((item) => {
        return {
            id: item._id,
            createdAt: item.createdAt,
            memberId: item.memberId,
            deposit: item.depositAmount || 0,
            refCount: item.refCount,
            phone: item.mobileNumber,
            referal: item.referal,
            email: item.email,
            status: item.status,
            name: item.firstName + " " + item.lastName,
            planMember: item.planMember,
        };
    });

    const options = {
        selectableRows: false,
        rowsPerPage: rowsPerPage,
        serverSide: true,
        filter: false,
        print: false,
        elevation: 0,
        count: totalMembers,
        textLabels: {
            body: {
                noMatch: "No members match this search",
            },
        },
        onChangeRowsPerPage: (numberOfRows) => {
            setRowsPerPage(numberOfRows);
            dispatch(fetchMembersRequest({
                page: page,
                pageSize: numberOfRows
            }));
        },
        onSearchClose: () => {
            setSearchText("");
            dispatch(fetchMembersRequest({
                page: page,
                pageSize: rowsPerPage,
                search: ""
            }));
        },
        onTableChange: (action, tableState) => {
            if (action === "changePage") {
                setPage(tableState.page);
                dispatch(fetchMembersRequest({
                    page: tableState.page,
                    pageSize: rowsPerPage,
                    search: searchText
                }));
            } else if (action === "search") {
                setSearchText(tableState.searchText);
                if (tableState.searchText && (tableState.searchText.length > 2 || tableState.searchText.length === 0)) {
                    dispatch(fetchMembersRequest({
                        page: page,
                        pageSize: rowsPerPage,
                        search: tableState.searchText
                    }));
                }
            }
        }
    };

    const selectedName = `${selectedItem.firstName || ""} ${selectedItem.lastName || ""}`.trim();

    return (
        <div className='member-page'>
            {
                isLoading && <Loader />
            }
            <Dialog maxWidth="md" fullWidth open={open} onClose={() => {
                setOpen(false)
            }} PaperProps={{ className: 'member-dialog' }}>
                <div className="member-hero">
                    <span className="member-hero-avatar">{initialsOf(selectedItem.firstName, selectedItem.lastName)}</span>
                    <div className="member-hero-body">
                        <h3>{selectedName || "Member Information"}</h3>
                        <div className="member-hero-meta">
                            <span className="member-hero-id">#{selectedItem.memberId}</span>
                            <StatusPill status={selectedItem.status} fallback="Unknown" />
                            {selectedItem.isEmailVerified
                                ? <span className="member-pill member-pill-ok">Email verified</span>
                                : <span className="member-pill member-pill-muted">Email pending</span>}
                            {selectedItem.isMobileVerified
                                ? <span className="member-pill member-pill-ok">Mobile verified</span>
                                : <span className="member-pill member-pill-muted">Mobile pending</span>}
                        </div>
                    </div>
                    <IconButton className="member-hero-close" onClick={() => setOpen(false)}>
                        <Close />
                    </IconButton>
                </div>
                <DialogContent>
                    <AppBar className="member-tabs" color="primary" variant='outlined' position="static">
                        <Tabs value={value} variant="scrollable" scrollButtons="auto" onChange={handleChange} aria-label="member details tabs">
                            <Tab label="Profile" {...a11yProps(0)} />
                            <Tab label="Referal" {...a11yProps(1)} />
                            <Tab label="Plans" {...a11yProps(2)} />
                            <Tab label="Withdraws" {...a11yProps(3)} />
                            <Tab label="Buy/Sell" {...a11yProps(4)} />
                            <Tab label="Payouts" {...a11yProps(5)} />
                            <Tab label="Contracts" {...a11yProps(6)} />
                        </Tabs>
                    </AppBar>
                    {
                        value === 0 &&
                        <Grid container spacing={2} className="member-grid">
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Section icon={<Person />} title="Identity" note="Account & contact details">
                                    <Grid container spacing={2} className="member-grid">
                                        <Field icon={<Fingerprint />} label="Member ID" value={selectedItem.memberId}
                                            trailing={<CopyButton value={selectedItem.memberId} label="Member ID" />} />
                                        <Field icon={<Person />} label="Member Name" value={selectedName} />
                                        <Field icon={<Phone />} label="Mobile Number" value={selectedItem.mobileNumber}
                                            trailing={selectedItem.isMobileVerified
                                                ? <span className="member-pill member-pill-ok">Verified</span>
                                                : <span className="member-pill member-pill-muted">Pending</span>} />
                                        <Field icon={<Email />} label="Email" value={selectedItem.email}
                                            trailing={selectedItem.isEmailVerified
                                                ? <span className="member-pill member-pill-ok">Verified</span>
                                                : <span className="member-pill member-pill-muted">Pending</span>} />
                                        <Field icon={<CalendarToday />} label="Joined Date"
                                            value={selectedItem.createdAt ? moment(selectedItem.createdAt).format("lll") : ""} />
                                        <Field icon={<Star />} label="Refered By" value={selectedItem.referal} />
                                        <Field icon={<AccountBalanceWallet />} label="Wallet Address" value={selectedItem.walletAddress}
                                            trailing={<CopyButton value={selectedItem.walletAddress} label="Wallet address" />} />
                                        <Field icon={<AccountBalanceWalletRounded />} label="Withdraw Address" value={selectedItem.withdrawAddress}
                                            trailing={<CopyButton value={selectedItem.withdrawAddress} label="Withdraw address" />} />
                                    </Grid>
                                </Section>
                                {
                                    (selectedItem.nomineeName || selectedItem.nomineeDOB || selectedItem.nomineeRelation) &&
                                    <Section icon={<Person />} title="Nominee">
                                        <Grid container spacing={2} className="member-grid">
                                            {selectedItem.nomineeName &&
                                                <Field md={4} icon={<Person />} label="Nominee Name" value={selectedItem.nomineeName} />}
                                            {selectedItem.nomineeDOB &&
                                                <Field md={4} icon={<CalendarToday />} label="Nominee DOB"
                                                    value={moment(selectedItem.nomineeDOB).format("LL")}
                                                    trailing={<span className="member-field-hint">{moment(selectedItem.nomineeDOB).fromNow()}</span>} />}
                                            {selectedItem.nomineeRelation &&
                                                <Field md={4} icon={<KeyboardHideSharp />} label="Nominee Relationship" value={selectedItem.nomineeRelation} />}
                                        </Grid>
                                    </Section>
                                }
                            </Grid>
                            {
                                selectedItem && selectedItem.walletAddress &&
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <div className="member-wallet">
                                        <div className="member-wallet-head">
                                            <img src={process.env.PUBLIC_URL + "BNB.png"} alt="BNB" />
                                            <div>
                                                <strong>BNB Wallet</strong>
                                                <span>Secured by Bicoince Wallet</span>
                                            </div>
                                        </div>
                                        <div className="member-wallet-body">
                                            <div className="member-wallet-address"
                                                onClick={() => copyToClipboard(selectedItem.walletAddress, "Address")}>
                                                <span>{selectedItem.walletAddress}</span>
                                                <FileCopy />
                                            </div>
                                            {
                                                walletInfo && walletInfo.coinPrice ?
                                                    <div className="member-balances">
                                                        <div className="member-balance member-balance-usdt">
                                                            <strong>{walletInfo.usdtTokenBalance}</strong>
                                                            <span>USDT</span>
                                                        </div>
                                                        <div className="member-balance member-balance-bnb">
                                                            <strong>{walletInfo.coinBalance}</strong>
                                                            <span>BNB</span>
                                                        </div>
                                                        <div className="member-balance member-balance-token">
                                                            <strong>{walletInfo.tokenBalance}</strong>
                                                            <span>T369</span>
                                                        </div>
                                                    </div> :
                                                    <div className="member-wallet-note">Balances are not available right now</div>
                                            }
                                        </div>
                                    </div>
                                </Grid>
                            }
                            <Grid item xs={12} sm={12} md={selectedItem.walletAddress ? 6 : 12} lg={selectedItem.walletAddress ? 6 : 12}>
                                <Section icon={<VpnKey />} title="Account Actions">
                                    <div className="member-actions">
                                        <Button
                                            className={selectedItem.status === "Active" ? "member-action-danger" : "member-action-success"}
                                            onClick={() => {
                                                Swal.fire({
                                                    icon: "question",
                                                    title: selectedItem.status === "Active" ? "Suspend User" : "Resume User",
                                                    text: `Are you sure want to ${selectedItem.status === "Active" ? "Suspend User" : "Resume User"} ${selectedItem.memberId}`,
                                                    confirmButtonText: "Yes Proceed",
                                                    showCancelButton: true
                                                }).then((x) => {
                                                    if (x.isConfirmed) {
                                                        if (selectedItem.status === "Active") {
                                                            dispatch(suspendMemberRequest(selectedItem.memberId));
                                                        }
                                                        else {
                                                            dispatch(resumeMemberRequest(selectedItem.memberId));
                                                        }
                                                    }
                                                })
                                            }} fullWidth>
                                            {selectedItem.status === "Active" ? <Block /> : <PlayCircleOutline />}
                                            {selectedItem.status === "Active" ? "Suspend User" : "Resume User"}
                                        </Button>
                                        <Button onClick={() => {
                                            Swal.fire({
                                                icon: "question",
                                                title: "Reset Password",
                                                text: `Are you sure want to reset password for ${selectedItem.memberId}`,
                                                confirmButtonText: "Yes Proceed",
                                                showCancelButton: true
                                            }).then((x) => {
                                                if (x.isConfirmed) {
                                                    dispatch(resetMemberRequest(selectedItem.memberId))
                                                }
                                            })
                                        }} fullWidth>
                                            <VpnKey />
                                            Reset Password
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                if (selectedItem.walletAddress) {
                                                    if (!selectedItem.isTokenApproved) {
                                                        dispatch(approveTokenRequest(selectedItem.memberId))
                                                    }
                                                }
                                            }}
                                            disabled={!selectedItem.walletAddress || selectedItem.isTokenApproved}
                                            fullWidth>
                                            <CheckCircleOutline />
                                            {selectedItem.isTokenApproved ? "Already Approved" :
                                                !selectedItem.walletAddress ? "Wallet not created" :
                                                    "Approve Token Request"}
                                        </Button>
                                        <Button fullWidth>
                                            <Layers />
                                            Join Plan
                                        </Button>
                                    </div>
                                </Section>
                            </Grid>
                        </Grid>
                    }
                    {
                        value === 1 &&
                        <div className="member-tab-panel">
                            <ReferalContainer />
                        </div>
                    }
                    {
                        value === 2 &&
                        <div className="member-tab-panel">
                            <Grid container spacing={2} className="member-grid">
                                {
                                    planMembers && planMembers.map((s, index) => {
                                        let planDetail = _.find(plans, z => z._id === s.planId);
                                        let duration = moment(s.maturityDate).diff(moment(s.createdAt), "day");
                                        let completed = moment().diff(moment(s.createdAt), "day");
                                        completed = parseInt(completed * 100 / duration);
                                        if (isNaN(completed) || completed < 0) completed = 0;
                                        if (completed > 100) completed = 100;
                                        return <Grid item md={4} lg={4} sm={12} xs={12} key={s._id || index}>
                                            <div className="member-plan-card">
                                                <div className="member-plan-head">
                                                    <span className="member-plan-index">{index + 1}</span>
                                                    <div>
                                                        <strong>{planDetail && planDetail.planName}</strong>
                                                        <span>{planDetail && planDetail.duration + " months"}</span>
                                                    </div>
                                                </div>
                                                <ul className="member-plan-rows">
                                                    <li><span>Joined Date</span><strong>{moment(s.createdAt).format("ll")}</strong></li>
                                                    <li><span>Maturity Date</span><strong>{moment(s.maturityDate).format("ll")}</strong></li>
                                                    <li><span>Duration</span><strong>{moment(s.maturityDate).diff(moment(s.createdAt), "month")} Months</strong></li>
                                                    <li><span>Amount</span><strong>{s.amount} USD</strong></li>
                                                </ul>
                                                <div className="member-plan-progress">
                                                    <div className="member-plan-progress-label">
                                                        <span>Tenure completed</span>
                                                        <strong>{completed}%</strong>
                                                    </div>
                                                    <LinearProgress value={completed} variant="determinate" />
                                                </div>
                                            </div>
                                        </Grid>
                                    })
                                }
                                {
                                    planMembers && planMembers.length === 0 &&
                                    <Grid item xs={12}>
                                        <EmptyState title="No plans found" text="This member has not subscribed to any plan yet." />
                                    </Grid>
                                }
                            </Grid>
                        </div>
                    }
                    {
                        value === 3 &&
                        <div className="member-tab-panel">
                            {
                                withdraws && withdraws.length === 0 &&
                                <EmptyState title="No withdraws found" text="Withdraw requests raised by this member will appear here." />
                            }
                            {
                                withdraws.map((t, index) => (
                                    <AccordionRow
                                        key={t._id || index}
                                        status={t.status}
                                        cells={[
                                            { label: "Date", value: moment(t.createdAt).format("lll") },
                                            { label: "Amount", value: t.isToken ? `${t.amount} ${t.tokenSymbol}` : `${t.amount} ${t.coinType}` },
                                            { label: "Reference", value: t.referenceNo },
                                        ]}>
                                        <Field icon={<Fingerprint />} label="Reference No" value={t.referenceNo}
                                            trailing={<CopyButton value={t.referenceNo} label="Reference no" />} />
                                        <Field icon={<TransferWithinAStation />} label="Transaction ID" value={t.transactionId}
                                            trailing={<CopyButton value={t.transactionId} label="Transaction ID" />} />
                                        <Field icon={<Money />} label="Amount" value={t.amount + " " + (t.isToken ? t.tokenSymbol : t.coinType)} />
                                        <Field icon={<CalendarToday />} label="Transaction Date" value={moment(t.createdAt).format("lll")} />
                                        {
                                            t.coinType &&
                                            <Field md={12} icon={<Code />} label="Transaction Hash" value={t.transactionhash}
                                                trailing={
                                                    <a target='_blank' rel="noreferrer" href={getTransactionUrl(t.coinType) + t.transactionhash}>
                                                        <Tooltip title="View on explorer">
                                                            <IconButton className="member-copy"><OpenInNew /></IconButton>
                                                        </Tooltip>
                                                    </a>
                                                } />
                                        }
                                        <Field icon={<Star />} label="Status" value={<StatusPill status={t.status} />} />
                                    </AccordionRow>
                                ))
                            }
                        </div>
                    }
                    {
                        value === 4 &&
                        <div className="member-tab-panel">
                            {
                                swaps && swaps.length === 0 &&
                                <EmptyState title="No buy / sell found" text="Token swap activity for this member will appear here." />
                            }
                            {
                                swaps.map((t, index) => (
                                    <AccordionRow
                                        key={t._id || index}
                                        status={t.status}
                                        cells={[
                                            { label: "Date", value: moment(t.createdAt).format("lll") },
                                            { label: "Type", value: t.swapType },
                                            { label: "Volume", value: t.tokenAddress ? `${t.transactionTokens} ${t.tokenSymbol}` : `${t.transactionCoins} ${t.coinType}` },
                                        ]}>
                                        <Field icon={<Fingerprint />} label="Reference No" value={t.referenceNo}
                                            trailing={<CopyButton value={t.referenceNo} label="Reference no" />} />
                                        <Field icon={<TransferWithinAStation />} label="Transaction ID" value={t.transactionId}
                                            trailing={<CopyButton value={t.transactionId} label="Transaction ID" />} />
                                        <Field icon={<Money />} label="Amount" value={t.transactionCoins + " " + (t.transactionMode === "USDT" ? "USDT" : t.coinType)} />
                                        <Field icon={<AccountBalanceWallet />} label="Tokens" value={t.transactionTokens + " " + t.tokenSymbol} />
                                        <Field icon={<AccountBalanceWalletRounded />} label="Transaction Charge" value={t.transactionCharge + " " + t.coinType} />
                                        <Field icon={<CalendarToday />} label="Transaction Date" value={moment(t.createdAt).format("lll")} />
                                        <Field icon={<FlipToBackRounded />} label="Token Address" value={t.tokenAddress && t.tokenAddress.toString()}
                                            trailing={<CopyButton value={t.tokenAddress} label="Token address" />} />
                                        <Field icon={<Person />} label="Created By" value={t.createdBy} />
                                        <Field md={12} icon={<Code />} label="Sender Hash" value={t.spentHash}
                                            trailing={<CopyButton value={t.spentHash} label="Sender hash" />} />
                                        <Field md={12} icon={<Code />} label="Receiver Hash" value={t.receiveHash}
                                            trailing={<CopyButton value={t.receiveHash} label="Receiver hash" />} />
                                        <Field md={12} icon={<Code />} label="Charge Hash" value={t.transactionChargeHash}
                                            trailing={<CopyButton value={t.transactionChargeHash} label="Charge hash" />} />
                                        <Field icon={<Star />} label="Status" value={<StatusPill status={t.status} />} />
                                    </AccordionRow>
                                ))
                            }
                        </div>
                    }
                    {
                        value === 5 &&
                        <div className="member-tab-panel">
                            {
                                payouts && payouts.length === 0 &&
                                <EmptyState title="No payouts found" text="Income and payout entries for this member will appear here." />
                            }
                            {
                                payouts.map((t, index) => (
                                    <AccordionRow
                                        key={t._id || index}
                                        status={t.status}
                                        cells={[
                                            { label: "Type", value: t.type },
                                            { label: "Date", value: moment(t.createdAt).format("lll") },
                                            { label: "Final Amount", value: `${t.finalAmount} USDT` },
                                        ]}>
                                        <Field icon={<Fingerprint />} label="Reference No" value={t._id}
                                            trailing={<CopyButton value={t._id} label="Reference no" />} />
                                        <Field icon={<TransferWithinAStation />} label="Type" value={t.type} />
                                        <Field icon={<Money />} label="Amount" value={t.amount + " USD"} />
                                        <Field icon={<CalendarToday />} label="Transaction Date" value={moment(t.createdAt).format("lll")} />
                                        <Field icon={<FormatAlignCenter />} label="From" value={t.createdBy} />
                                        <Field icon={<FlipToBackRounded />} label="To" value={t.memberId} />
                                        <Field icon={<Code />} label="Method" value={t.method} />
                                        <Field icon={<Code />} label="Reinvestment" value={t.reinvestment + " USD"} />
                                        <Field icon={<Code />} label="Liquidity" value={t.liquidity + " USD"} />
                                        <Field icon={<Code />} label="Gas Fees" value={t.adminFees + " USD"} />
                                        <Field icon={<Star />} label="Status" value={<StatusPill status={t.status} />} />
                                    </AccordionRow>
                                ))
                            }
                        </div>
                    }
                    {
                        value === 6 &&
                        <div className="member-tab-panel">
                            {
                                contracts && contracts.length === 0 &&
                                <EmptyState title="No contracts found" text="On-chain contract calls for this member will appear here." />
                            }
                            {
                                contracts.map((t, index) => (
                                    <AccordionRow
                                        key={t._id || index}
                                        status={t.status}
                                        cells={[
                                            { label: "Method", value: t.method },
                                            { label: "Date", value: moment(t.createdAt).format("lll") },
                                            { label: "Amount", value: `${t.amount} Tokens` },
                                        ]}>
                                        <Field icon={<Fingerprint />} label="Reference No" value={t._id}
                                            trailing={<CopyButton value={t._id} label="Reference no" />} />
                                        <Field icon={<TransferWithinAStation />} label="Method" value={t.method} />
                                        <Field icon={<Money />} label="Amount" value={t.amount + " Tokens"} />
                                        <Field icon={<CalendarToday />} label="Transaction Date" value={moment(t.createdAt).format("lll")} />
                                        <Field icon={<Email />} label="Email" value={t.userEmail}
                                            trailing={<CopyButton value={t.userEmail} label="Email" />} />
                                        <Field icon={<Person />} label="Created By" value={t.createdBy} />
                                        <Field md={12} icon={<Code />} label="Transaction Hash" value={t.transactionHash}
                                            trailing={<CopyButton value={t.transactionHash} label="Transaction hash" />} />
                                        <Field icon={<Star />} label="Status" value={<StatusPill status={t.status} />} />
                                        <Field md={12} icon={<Deck />} label="From Params" value={t.fromParams && t.fromParams.join(" | ")} />
                                        <Field md={12} icon={<Deck />} label="To Params" value={t.toParams && t.toParams.join(" | ")} />
                                    </AccordionRow>
                                ))
                            }
                        </div>
                    }
                </DialogContent>
            </Dialog>

            <TitleBar heading="Members" secondary={""}
                icon={<People />}
                action={<Button color="primary" onClick={() => mode === "add" ? setMode("") : setMode("add")} variant='contained'>{
                    mode === "add" ? "View Member" : "Add Member"
                }</Button>}
            />

            {
                mode !== "add" && mode !== "edit" &&
                <div className="member-stats">
                    {
                        stats.map((stat) => (
                            <div className={`member-stat member-stat-${stat.tone}`} key={stat.key}>
                                <span className="member-stat-icon">{stat.icon}</span>
                                <span className="member-stat-body">
                                    <span className="member-stat-value">{stat.value}</span>
                                    <span className="member-stat-label">{stat.label}</span>
                                    <span className="member-stat-note">{stat.note}</span>
                                </span>
                            </div>
                        ))
                    }
                </div>
            }

            {
                mode === "add" ?
                    <div className="member-form-surface">
                        <div className="member-section-head">
                            <Person />
                            <h4>New Member</h4>
                            <small>Register a member into the network</small>
                        </div>
                        <AddMember members={members} />
                    </div> :
                    mode === "edit" ?
                        <div className="member-form-surface">
                            <div className="member-section-head">
                                <Edit />
                                <h4>Edit Member</h4>
                                <small>#{selectedItem.memberId}</small>
                            </div>
                            <UpdateMember members={members} onClose={() => {
                                setMode("list");
                                setSelecteItem({});
                            }} selectedMember={selectedItem} />
                        </div> :
                        <div className="member-list-surface">
                            <div className="member-table-scroll">
                                <MUIDataTable
                                    title={"Member Directory"}
                                    data={datum}
                                    columns={columns}
                                    options={options}
                                />
                            </div>
                        </div>
            }
        </div>
    );
}
